import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyITTabletDefaultAPI from '../api';

const patchITTabletActive = async ({ seq }) => {
  try {
    const response = await safetyITTabletDefaultAPI.patch(`/${seq}/active`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default patchITTabletActive;
